import './app.css';

import WebFont from 'webfontloader';
import {analyticsEvent, attrEvents} from './js/analytics';

import Swiper from 'swiper';

/* is production */
const isProd = process.env.NODE_ENV === 'production';

/* fonts */
WebFont.load({
    custom: {
        families: ['Proxima Nova:n6,n7,n8', 'Bebas Neue:n1'],
        urls: ['./css/fonts.css']
    },
    google: {
        families: ['Raleway:500,700,800:cyrillic']
    }
    /*
    typekit: {
        id: 'xxxxxx'
    }*/
});

/* analytics (EXAMPLE: analyticsEvent('Button', 'click', 'Play');) */
/* <button data-event="click" data-event-category="Button" data-event-label="Play"> */
analyticsEvent();
attrEvents();

/* service worker */
if ('serviceWorker' in navigator && isProd) {
    import(/* webpackPrefetch: true */ './js/sw').then(func => {
        func.default();
    });
}

/* lazy loading (https://github.com/verlok/lazyload) */
if (document.querySelector('.lazy') !== null) {
    import(/* webpackPrefetch: true */ './js/lazyloading').then(func => {
        func.default();
    });
}

/* share buttons */
if (document.querySelector('.share') !== null) {
    import(/* webpackPrefetch: true */ './js/share').then(func => {
        func.default();
    });
}

const isMobile = function() {
    return window.innerWidth <= 425 || window.innerHeight <= 425;
};

const descPosition = isMobile() ? 103 : 15.8;
const picPosition = isMobile() ? -103 : -18.5;
const units = isMobile() ? '%' : 'em';
const noSwiping = !isMobile();
const freeMode = true;
const speed = isMobile() ? 900 : 300;

const currentStepAnimate = [0, 0, 0, 0, 0];
const swipers = [];
const swiperContainers = document.querySelectorAll('.section__answer--wrap');

let lastProgress = 0;
let directionScroll = null;
let currentActiveSwIndex = -1;
const targetPoint = isMobile() ? document.documentElement.clientHeight * 0.2 : document.documentElement.clientHeight * 0.3;

const isStartAnimate = function(index) {
    return (directionScroll === 'up' && swipers[index].isBeginning) || (directionScroll === 'down' && swipers[index].isEnd);
};

const onPause = function() {
    mainSwiper.mousewheel.disable();
    mainSwiper.allowTouchMove = false;
};

const offPause = function() {
    mainSwiper.mousewheel.enable();
    mainSwiper.allowTouchMove = true;
};

const setOnAnimate = function(index) {
    swipers[index].mousewheel.enable();
    swipers[index].$el[0].style.pointerEvents = 'all';
};

const setOffAnimate = function(index) {
    swipers[index].mousewheel.disable();
    swipers[index].$el[0].style.pointerEvents = 'none';
    currentActiveSwIndex = -1;
};

const checkActiveSwiper = function() {
    for (let i = 0; i < swipers.length; i++) {
        const swCoord = swipers[i].$el[0].getBoundingClientRect();
        if (swCoord.top > 0 && swCoord.top <= targetPoint && swCoord.bottom >= targetPoint) {
            currentActiveSwIndex = i;
            return {index: i, sw: swipers[i]};
        }
    }
    return;
};

const resetPause = function() {
    offPause();
    if (currentActiveSwIndex >= 0) setOffAnimate(currentActiveSwIndex);
};

/* init swiper */
/* eslint-disable no-unused-vars */
const mainSwiper = new Swiper('.swiper-container', {
    direction: 'vertical',
    speed: speed,
    slidesPerView: 'auto',
    parallax: true,
    freeMode: freeMode,
    autoHeight: true,
    mousewheel: true,
    noSwiping: noSwiping,

    freeModeMomentum: false,

    longSwipes: false,
    allowTouchMove: true,
    // touchMoveStopPropagation: false,

    pagination: {
        el: '.swiper-pagination',
        clickable: true
    },
    on: {
        progress: function() {
            directionScroll = lastProgress < this.progress ? 'down' : lastProgress > this.progress ? 'up' : null;
            lastProgress = this.progress;
            if (directionScroll != null) {
                if (swipers.length === 5) {
                    const activeSw = checkActiveSwiper();
                    if (activeSw != null) {
                        if (!isStartAnimate(activeSw.index)) {
                            onPause();
                            setOnAnimate(activeSw.index);
                        }
                    }
                }
            }

            if (this.progress > 0.01) {
                const el = document.querySelector('.main__scroll-icon');
                if (el.classList.contains('hidden')) return;
                el.classList.add('hidden');
            } else {
                const el = document.querySelector('.main__scroll-icon');
                if (!el.classList.contains('hidden')) return;
                el.classList.remove('hidden');
            }
        },
        transitionStart: function() {
            if (!isMobile()) return;
            setOpacityBullets('1');
        },
        transitionEnd: function() {
            if (!isMobile()) return;
            setOpacityBullets('0.3');
        },
        touchStart: function() {
            if (!isMobile() || !this.mousewheel.enabled) return;
            setOpacityBullets('1');
        },
        touchEnd: function() {
            if (!isMobile() || currentOpacityBullets === '0.3') return;
            setOpacityBullets('0.3');
        },
        slideChange: function() {
            analyticsEvent('SlideChange', 'scroll', `GoTo${this.activeIndex}Slide`);
        }
    }
});

mainSwiper.mouseEntered = true;
// mainSwiper.slideTo(0, 0);

for (let index = 0; index < swiperContainers.length; index++) {
    const item = swiperContainers[index];
    const swiper = new Swiper(`.swiper-container-answ${[index]}`, {
        direction: 'vertical',
        speed: 1000,
        mousewheel: true,
        // nested: true,
        noSwiping: false,

        on: {
            reachEnd: function() {
                setOffAnimate(index);
                setTimeout(offPause, 500);
            },
            reachBeginning: function() {
                setOffAnimate(index);
                setTimeout(offPause, 500);
            },
            slideNextTransitionStart: function() {
                currentStepAnimate[index]++;
                const desc = document.querySelector(`.swiper-container-answ${index} .section__answer--box-${currentStepAnimate[index]}`);
                const pic = document.querySelector(`.swiper-container-answ${index} .section__answer--picture-${currentStepAnimate[index]}`);
                desc.style.transform = 'translateX(0)';
                desc.style.filter = 'blur(0px)';
                pic.style.transform = 'translateX(0)';
                pic.style.filter = 'blur(0px)';
            },
            slidePrevTransitionStart: function() {
                const desc = document.querySelector(`.swiper-container-answ${index} .section__answer--box-${currentStepAnimate[index]}`);
                const pic = document.querySelector(`.swiper-container-answ${index} .section__answer--picture-${currentStepAnimate[index]}`);
                const direction = index % 2 === 0 ? 1 : -1;
                desc.style.transform = `translateX(${descPosition * direction}${units})`;
                desc.style.filter = 'blur(3px)';
                pic.style.transform = `translateX(${picPosition * direction}${units})`;
                pic.style.filter = 'blur(3px)';
                currentStepAnimate[index]--;
            },
            slideChange: function() {
                analyticsEvent('CardChange', 'scroll', `GoTo${this.activeIndex}CardOn${index}Slide`);
            }
        }
    });
    swipers.push(swiper);
}
/* eslint-enable no-unused-vars */

/* add reset pause on click bullet */
const bullets = document.querySelectorAll('.swiper-pagination-bullet');
let currentOpacityBullets = 0;
for (let i = 0; i < bullets.length; i++) {
    bullets[i].addEventListener('click', function() {
        setTimeout(resetPause, 100);
    });
}

const setOpacityBullets = function(value) {
    currentOpacityBullets = value;
    for (let i = 0; i < bullets.length; i++) {
        bullets[i].style.opacity = value;
    }
};
